// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#searchAddressModal {
    width: 90%;
    max-width: 1000px;
    height: 90%;
    max-height: 600px;
}
#searchAddressModal .list_table{
    font-size: min(2.3Vw, 16px);
}
#searchAddressModal tbody .table-body:hover {
    background-color: #e3e3e3;
}

#searchAddressModal .pagingBtn {
    display: flex;
    justify-content: space-around;
    width: 60%;
    margin: 48px auto;
}

#searchAddressModal .pagingBtn button {
    border: 1px solid white;
    font-size: 14.4px;
    padding: 4.8px 8px;
    margin: 0 3.2px;
    background-color: #FFFFFF;
    line-height: 16px;
}

#searchAddressModal .pagingBtn button:hover {
    background-color: #f0f0f0;
    color: black;
}

#searchAddressModal .pagingBtn button:disabled {
    background-color: white;
    cursor: not-allowed;
}

#searchAddressModal .firstPage:before, #searchAddressModal .previousPage:before, #searchAddressModal .nextPage:before, #searchAddressModal .lastPage:before {
    font-size: 16px;
}

.addressSearchBar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 2px solid #323232;
}

.addressSearchBar > input {
    width: 80%;
    outline-style: none;
    height: 32px;
    font-size: 17.6px;
    padding: 0 8px;
    border: none;
}

.addressSearchBar > button {
    width: 20%;
    height: 38.4px;
    outline-style: none;
    border-radius: 0;
}
.addressSearchBar > button:disabled{
    cursor: not-allowed;
}

.addressSearchBar > button:disabled:hover{
    background-color: #323232;
}

.address-notice {
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 16px 0;
}

.address-notice p {
    font-weight: bold;
    font-size: min(2.5Vw, 15px);
}

.address-notice ul {
    padding: 0 16px;
    list-style: square;
}

.address-notice ul li {
    font-size: min(2Vw, 13px);
}

@media screen and (max-width: 900px) {
    #searchAddressModal {
        height: 90%;
    }

    #searchAddressModal .pagingBtn{
        margin: 48px auto 24px auto;
    }

    #searchAddressModal .pagingBtn button{
        font-size: calc(80%);
        padding: 3px 8px;
        margin: auto;
    }
    #searchAddressModal .firstPage:before, #searchAddressModal .previousPage:before, #searchAddressModal .nextPage:before, #searchAddressModal .lastPage:before{
        font-size: min(13px, 3vw);
    }
}

@media screen and (max-width: 600px) {
    #searchAddressModal {
        height: 70%;
        /*min-height: 400px;*/
    }

}`, "",{"version":3,"sources":["webpack://./src/styles/Modal_SearchAddress.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,iBAAiB;IACjB,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,oBAAoB;QACpB,gBAAgB;QAChB,YAAY;IAChB;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,WAAW;QACX,qBAAqB;IACzB;;AAEJ","sourcesContent":["#searchAddressModal {\n    width: 90%;\n    max-width: 1000px;\n    height: 90%;\n    max-height: 600px;\n}\n#searchAddressModal .list_table{\n    font-size: min(2.3Vw, 16px);\n}\n#searchAddressModal tbody .table-body:hover {\n    background-color: #e3e3e3;\n}\n\n#searchAddressModal .pagingBtn {\n    display: flex;\n    justify-content: space-around;\n    width: 60%;\n    margin: 48px auto;\n}\n\n#searchAddressModal .pagingBtn button {\n    border: 1px solid white;\n    font-size: 14.4px;\n    padding: 4.8px 8px;\n    margin: 0 3.2px;\n    background-color: #FFFFFF;\n    line-height: 16px;\n}\n\n#searchAddressModal .pagingBtn button:hover {\n    background-color: #f0f0f0;\n    color: black;\n}\n\n#searchAddressModal .pagingBtn button:disabled {\n    background-color: white;\n    cursor: not-allowed;\n}\n\n#searchAddressModal .firstPage:before, #searchAddressModal .previousPage:before, #searchAddressModal .nextPage:before, #searchAddressModal .lastPage:before {\n    font-size: 16px;\n}\n\n.addressSearchBar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border: 2px solid #323232;\n}\n\n.addressSearchBar > input {\n    width: 80%;\n    outline-style: none;\n    height: 32px;\n    font-size: 17.6px;\n    padding: 0 8px;\n    border: none;\n}\n\n.addressSearchBar > button {\n    width: 20%;\n    height: 38.4px;\n    outline-style: none;\n    border-radius: 0;\n}\n.addressSearchBar > button:disabled{\n    cursor: not-allowed;\n}\n\n.addressSearchBar > button:disabled:hover{\n    background-color: #323232;\n}\n\n.address-notice {\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    padding: 16px 0;\n}\n\n.address-notice p {\n    font-weight: bold;\n    font-size: min(2.5Vw, 15px);\n}\n\n.address-notice ul {\n    padding: 0 16px;\n    list-style: square;\n}\n\n.address-notice ul li {\n    font-size: min(2Vw, 13px);\n}\n\n@media screen and (max-width: 900px) {\n    #searchAddressModal {\n        height: 90%;\n    }\n\n    #searchAddressModal .pagingBtn{\n        margin: 48px auto 24px auto;\n    }\n\n    #searchAddressModal .pagingBtn button{\n        font-size: calc(80%);\n        padding: 3px 8px;\n        margin: auto;\n    }\n    #searchAddressModal .firstPage:before, #searchAddressModal .previousPage:before, #searchAddressModal .nextPage:before, #searchAddressModal .lastPage:before{\n        font-size: min(13px, 3vw);\n    }\n}\n\n@media screen and (max-width: 600px) {\n    #searchAddressModal {\n        height: 70%;\n        /*min-height: 400px;*/\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
